import { dataFix } from '../../common/dataFix';
import { _settingsFs } from './getSettings';

/** Updates the `settings_globalPageItems' collection
 * @collection settings_globalPageItems
 * @doc all
 */
export const globalPageItems_update = (previewInfo, dispatch) => {
  const d = { viewItems: dataFix.removeEmpties(previewInfo) }
  database_fns.set_doc(['settings_global_pageItems', 'all'], d, false, dispatch)
}

/** This will create settings_globalPageItems from all the existing viewItems for ALL the settings */
export const globalPageItems_preview = (dispatch) => {
  database_fns.get_data({ refPath: [_settingsFs.root] }).then(_allSettings => {
    const vis = {}
    Object.keys(_allSettings).forEach(key => {
      const setting = _allSettings[key]
      if (setting && setting.viewItems) {
        Object.keys(setting.viewItems).forEach(viKey => {
          if (viKey.indexOf('golf') < 0 && viKey.indexOf('lab') < 0 && viKey.indexOf('run') < 0 && viKey.indexOf('holes') < 0) {
            const globalVi = setting.viewItems[viKey]
            // check validity
            if (globalVi && globalVi.propSections && globalVi.dataConnection) {
              vis[viKey] = { ...globalVi }
              delete vis[viKey].data
              delete vis[viKey].side
            }
          }
        })
      }
    })
    const d = { viewItems: vis }
    dispatch({ type: 'showPreview', previewInfo: d });
  })
}